import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ButtonGroup from '../../components/button-group';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './confirmation.scss';

const Confirmation = ({
  icon,
  title,
  children,
  confirm,
  onConfirm,
  cancel,
  onCancel,
  titleFontClassName,
  contentFontClassName,
}) => {
  const Icon = icon;
  return (
    <div className={classNames(styles.container, contentFontClassName, 'forum-text-color')}>
      <h3 className={classNames(styles.titleContainer, titleFontClassName)}>
        <Icon className={classNames(styles.icon, 'forum-icon-fill')}/>
        <span className={classNames(styles.title, 'confirmation__title')} data-hook="confirmation__title">
          {title}
        </span>
      </h3>
      {children &&
        <div className={styles.content} data-hook="confirmation__content">
          {children}
        </div>}
      <ButtonGroup
        primaryButtonText={confirm}
        primaryButtonProps={{ onClick: () => onConfirm() }}
        secondaryButtonText={cancel}
        secondaryButtonProps={{ onClick: () => onCancel() }}
      />
    </div>
  );
};

Confirmation.propTypes = {
  icon: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  confirm: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  cancel: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  titleFontClassName: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
};

export default withFontClassName(Confirmation);



// WEBPACK FOOTER //
// ./app/components/confirmation/confirmation.js